/**
 * TODO 当前文件属于产品卡片配置文件，通过配置的方式完成业务功能的开发，实现组件的高内聚、低耦合
 * 配置文件说明如下
 *  ProductCfg 对象最外层的包裹文件
 *    planType 规划类型
 *    subType 规划类型下子类型 如： 寿险、年金
 *    insuranceType 保险类型
 *    listPage 列表页模块的配置文件
 *      tableCfg 表格相关配置文件 详情请见 src/components/TsTable/TsTable.vue  表格demo请见 src/components/TsTable/demo.vue
 *      btmBtnList 表格底部按钮数组 接口详情请见 src/types/common/btn.d.ts
 *    editSettings 新增编辑模块配置文件
 *      countUrlFn 分析结果接口函数
 *      inpOutFormList 页面输出项表单数组数据
 */

import { ProductCfg } from '@/types/newPersion'
import { statisticsList } from '@/api/newPersion'
const ProductCfg: ProductCfg = {
  planType: 'Pension',
  subType: 'life',
  insuranceType: 'LifeInsurance',
  lifelongLifeInsurance: true,
  listPage: {
    tableCfg: {
      titleObjCfg: {
        // title: '增额终身寿产品选择',
        hide: true,
        // options: {
        //   dropdown: false,
        //   arr: [
        //     {
        //       type: 'add',
        //       name: '新增终身寿产品'
        //     }
        //   ]
        // }
      },
      tableHead: [
        {
          propName: 'insuredName',
          labelName: '被保险人'
        },
        {
          // type: 'first',
          propName: 'insuranceName',
          labelName: '被保险产品名称'
        },
        {
          type: 'edit',
          labelName: '编辑',
          propName: 'edit',
          options: {
            dropdown: false,
            arr: [

              {
                type: 'edit',
                name: '编辑',
                btnType: 'text'
              }, {
                type: 'del',
                name: '删除',
                btnType: 'text'
              }
            ]
          }
        }
      ],
      // listUrlParams: {
      //   insuranceType: 'LifeInsurance',
      //   // storyLineType: 'Pension'
      // }
    },
    btmBtnList: [
      { name: '返回', btnType: 'no' },
      { name: '确定', btnType: 'ok' }
    ]
  },
  editSettings: {
    name: '增额终身寿险',
    countUrlFn: async (params: {}, urlFn?: Function) => {
      if (urlFn) {
        return await urlFn(params)
      } else {
        return await statisticsList(params)
      }
    },
    formObj: {
      customerMember: '',
      insuranceId: '',
      yearlyAmount: '',
      years: '',
    },
    formRuleList: ['customerMember', 'insuranceId', 'yearlyAmount', 'years'],
    inpOutFormList: [{
      disabled: true,
      label: '期末身故保障金:',
      suffix: '元',
      type: 'number',
      value: 'lifeBenefits',
      inputWidth: '400px'
    }, {
      disabled: true,
      label: '期末现金价值:',
      suffix: '元',
      type: 'number',
      value: 'cashValue',
      inputWidth: '400px'
    }, {
      disabled: true,
      label: '期末身故保障/总保费:',
      suffix: '倍',
      type: 'number',
      value: 'multiple',
      inputWidth: '400px'
    }, {
      disabled: true,
      label: '期末现金价值/总保费:',
      suffix: '倍',
      type: 'number',
      value: 'valueMultiple',
      inputWidth: '400px'
    }],
    chartEnum: {
      age: '',
      lifeMny: '寿险保额', // 寿险保额
      cashValue: '当年账户现金价值', // 当年账户现金价值
      yearMny: '年缴保费' // 年缴保费
    },
    tableHead: [
      {
        propName: 'age',
        labelName: '年龄'
      }, {
        propName: 'yearMny',
        labelName: '年缴保费(元)'
      }, {
        propName: 'cashValue',
        labelName: '当年现金价值(元)'
      }, {
        propName: 'lifeMny',
        labelName: '期末身故保障'
      }, {
        propName: 'bonus',
        labelName: '红利'
      },
    ]
  },
  outputSetting: {
    formInfoList: [
      {
        title: '产品名:',
        value: 'insuranceName',
        unit: '',
      },
      {
        title: '被保险人:',
        value: 'insuredName',
        unit: '',
      },
      {
        title: '年缴保费:',
        value: 'yearlyAmount',
        unit: '元',
      }, {
        title: '期末身故保额:',
        value: 'lifeInsuranceStatistics.lifeBenefits',
        unit: '元',
      },
      {
        title: '期末现金价值:',
        value: 'lifeInsuranceStatistics.cashValue',
        unit: '元',
      },
      {
        title: '期末身故保额/总保费:',
        value: 'lifeInsuranceStatistics.multiple',
        unit: '倍',
      },
      {
        title: '期末现金价值/总保费:',
        value: 'lifeInsuranceStatistics.valueMultiple',
        unit: '倍',
      }]
  }
}
export default ProductCfg
